import React, { Component } from "react";

import { NavLink } from "react-router-dom";
import "./header.css";

import AuthService from "../Auth/authservice";

const Auth = new AuthService();

class Header extends Component {
  signOut = () => {
    Auth.userLogout();
  };

  render() {
    return (
      <div className="Header-container">
        <div className="Header-title-container">
          <h3 className="header-title"> Dream Flowers Lighting </h3>
        </div>
        <div className="Header-login">
          {this.props.isLoggedIn ? (
            <NavLink
              exact
              activeClassName="selected"
              to="/"
              onClick={this.signOut}
            >
              Sign Out
            </NavLink>
          ) : (
            <div>
              <NavLink exact activeClassName="selected" to="/login">
                Login
              </NavLink>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Header;
